import React from 'react';
import { Modal, PhoneInput, Button, Typography } from '@vtblife/uikit';
import { Size } from '@vtblife/uikit/legacy';

import classname from '@search/classname/src';

import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { useRepairUserForm } from '../../useRepairUserForm';
import { useClassifiedOfferDataLayerPush } from '../../../../../../domain/offer/analytics/ClassifiedOfferGtmContext';

import RepairImg from './RepairImg.url.svg';

import './styles.css';

const cn = classname.bind(null, 'DesktopRepairGalleryBanner');

export const DesktopRepairGalleryBanner = ({ area }: { area: number }) => {
    const dataLayerPush = useClassifiedOfferDataLayerPush();
    const staticPath = useStaticPathConfig();

    React.useEffect(() => {
        dataLayerPush({
            event: 'up_action',
            theme: 'remont',
            page_type: 'card',
            type: 'gallery_count_click'
        });
    }, [ ]);

    const {
        isPhoneValid,
        sendRequest,
        totalPrice,
        meterPrice,
        resetForm,
        setPhone,
        isSent,
        phone
    } = useRepairUserForm({ place: 'gallery', area });

    return (
        <section className={cn()}>
            <img
                className={cn('picture')}
                crossOrigin='anonymous'
                src={`${staticPath}${RepairImg}`}
                alt='Картинка ремонта'
                width={178}
                height={178}
            />
            <div className={cn('content')}>
                <Typography variant='h2' color='black-500'>
                    Обновите ремонт через m2.ru
                </Typography>
                <Typography variant='primary' color='black-500' className={cn('subTitle')}>
                    Предварительная стоимость предчистового ремонта этой квартиры, с&nbsp;учётом черновых материалов
                </Typography>
                <div className={cn('price')}>
                    <Typography color='link-minor' variant='h3'>
                        {`от ${totalPrice} ₽`}
                    </Typography>
                    <Typography color='black-500' variant='h3' className={cn('dot')}>
                        ·
                    </Typography>
                    <Typography color='black-500' variant='h3'>
                        {`${meterPrice} ₽/м²`}
                    </Typography>
                </div>
                <div className={cn('userInfo')}>
                    <PhoneInput
                        label='Номер телефона'
                        size={Size.Large}
                        value={phone}
                        onChange={setPhone}
                    />
                    <Button
                        variant='promo1'
                        disabled={! isPhoneValid}
                        onClick={sendRequest}
                    >
                        Получить смету
                    </Button>
                </div>
                <Typography variant='secondary-alone' color='black-400'>
                    Расчёт опирается на&nbsp;средние цены от&nbsp;партнёров. Стоимость черновых работ посчитана на&nbsp;основе анализа смет.
                </Typography>
            </div>
            <Modal opened={isSent} onClose={resetForm}>
                <Typography variant='h3' color='black-500'>
                    Заявка принята
                </Typography>
            </Modal>
        </section>
    );
};
